import {
  Api,
  getCategoryList,
  recountTotal,
  recountProductsOverlays,
  getCategoryPos,
  getColumnSize,
  MOOD_LIST_MAIN,
  MOOD_LIST_ALTERNATIVE,
  showOnboardingMessage,
} from './common';
import { clone } from '../../../../common/common';
import { PRODUCTS_TAB, switchTab } from './tabs';

// ------------------------------------
// Constants
// ------------------------------------
export const MOOD_CATEGORY_LOADING = 'MOOD_CATEGORY_LOADING';
export const MOOD_REMOVE_PRODUCT = 'MOOD_REMOVE_PRODUCT';
export const MOOD_UPDATE_PRODUCT = 'MOOD_UPDATE_PRODUCT';
export const MOOD_SELECT_PRODUCT = 'MOOD_SELECT_PRODUCT';
export const MOOD_CATEGORY_SWITCH_RENAME = 'MOOD_CATEGORY_SWITCH_RENAME';
export const MOOD_CATEGORY_RENAME = 'MOOD_CATEGORY_RENAME';
export const MOOD_CATEGORY_CREATE = 'MOOD_CATEGORY_CREATE';
export const MOOD_CATEGORY_REMOVE = 'MOOD_CATEGORY_REMOVE';
export const MOOD_CATEGORY_CATEGORY_RELEASE = 'MOOD_CATEGORY_CATEGORY_RELEASE';
export const MOOD_CATEGORY_TOGGLE_FAVOURITE = 'MOOD_CATEGORY_TOGGLE_FAVOURITE';
export const MOOD_CATEGORY_COPY_DIALOG = 'MOOD_CATEGORY_COPY_DIALOG';
export const MOOD_CATEGORY_CATEGORY_RELEASE_REMOVE = 'MOOD_CATEGORY_CATEGORY_RELEASE_REMOVE';
export const MOOD_CATEGORY_PLACEHOLDER = 'MOOD_CATEGORY_PLACEHOLDER';
export const MOOD_DROP_BEFORE_CREATE = 'MOOD_DROP_BEFORE_CREATE';

export const CREATE_PLACEHOLDER_ACTION = 'create';
export const REMOVE_PLACEHOLDER_ACTION = 'remove';

// ------------------------------------
// Actions
// ------------------------------------

export function toggleCategoryRelease(category) {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      const categoryRelease = !category.category_release;
      dispatch({
        type: MOOD_CATEGORY_CATEGORY_RELEASE,
        payload: { category, categoryRelease },
      });

      Api.updateCategory(dispatch, category.id, { category_release: categoryRelease });

      resolve();
    });
  };
}

// categoryToCopyDialogClose

export function categoryToCopyDialogOpen(category) {
  return (dispatch, getState) => {
    dispatch({
      type: MOOD_CATEGORY_COPY_DIALOG,
      payload: { category },
    });
  };
}

export function categoryToCopyDialogClose() {
  return categoryToCopyDialogOpen(null);
}

// export function toggleCopyCategory(category) {
//   return (dispatch, getState) => {
//     return new Promise(resolve => {
//       // const prepareForCopy = !category.prepareForCopy;
//       const prepareForCopy = true;
//       dispatch({
//         type: MOOD_CATEGORY_COPY_DIALOG,
//         payload: { category, prepareForCopy },
//       });
//       // Api.prepare_category_for_copy(dispatch, category.id);
//       resolve();
//     });
//   };
// }

export function switchCategoryRename(category, isEditMode) {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      dispatch({
        type: MOOD_CATEGORY_SWITCH_RENAME,
        payload: { category, isEditMode },
      });

      if (!isEditMode) {
        Api.updateCategory(dispatch, category.id, { name: category.name });
      }

      resolve();
    });
  };
}

export function renameCategory(category, newName) {
  return { type: MOOD_CATEGORY_RENAME, payload: { category: category, newName: newName } };
}

export function updateMoodboardProduct(categoryId, product, event) {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      dispatch({
        type: MOOD_UPDATE_PRODUCT,
        payload: { categoryId, product: product },
      });
      Api.updateMoodboardProduct(dispatch, categoryId, product);

      resolve();
    });
  };
}

export function removeProduct(categoryId, list, product) {
  let confirmation = confirm('Do you really want to remove the item?');
  if (confirmation) {
    return (dispatch, getState) => {
      return new Promise(resolve => {
        dispatch({
          type: MOOD_REMOVE_PRODUCT,
          payload: { categoryId, list, product: product },
        });

        Api.removeProduct(dispatch, categoryId, list, product);

        resolve();
      });
    };
  }
  return { type: null, payload: null };
}

export function selectProductOnly(product) {
  return { type: MOOD_SELECT_PRODUCT, payload: { product: product } };
}

export function selectProduct(product) {
  return (dispatch, getState) => {
    dispatch(selectProductOnly(product));
    dispatch(switchTab(PRODUCTS_TAB));
  };
}

export function createCategory(dragObj, category, event) {
  let product = dragObj.product;
  if (product) {
    return (dispatch, getState) => {
      return new Promise(resolve => {
        event.stopPropagation();

        dispatch({ type: MOOD_DROP_BEFORE_CREATE, payload: null });
        Api.createCategory(dispatch, product, category, data => {
          dispatch({ type: MOOD_CATEGORY_CREATE, payload: data });

          if (dragObj.originCategory) {
            Api.removeProduct(dispatch, dragObj.originCategory.id, dragObj.originList, product);
          }
        });

        resolve();
      });
    };
  }
  return { type: null, payload: null };
}

export function removeCategory(category) {
  let confirmation = confirm('Do you really want to remove the category?');
  if (confirmation) {
    return (dispatch, getState) => {
      return new Promise(resolve => {
        Api.removeCategory(dispatch, category.id, data =>
          dispatch({ type: MOOD_CATEGORY_REMOVE, payload: category }),
        );
      });
    };
  }
  return { type: null, payload: null };
}

export const createNewCategoryPlaceholder = category => {
  return {
    type: MOOD_CATEGORY_PLACEHOLDER,
    payload: { category, action: CREATE_PLACEHOLDER_ACTION },
  };
};

export const removeNewCategoryPlaceholder = () => {
  return { type: MOOD_CATEGORY_PLACEHOLDER, payload: { action: REMOVE_PLACEHOLDER_ACTION } };
};

// ------------------------------------
// Functions
// ------------------------------------

const processLoading = (state, action) => {
  let newState = clone(state);
  newState.categories = newState.categories.map(category => {
    if (category.id === action.payload.categoryId) {
      category.loading = action.payload.loading;
    }
    return category;
  });
  return newState;
};

const processProductRemove = (state, action) => {
  let newState = clone(state);

  if (action.payload.categoryId && action.payload.product) {
    let processCategory = cat => {
      cat.active = false;
      if (cat.id === action.payload.categoryId) {
        let list = getCategoryList(cat, action);
        let index = list.findIndex(i => i.id === action.payload.product.id);
        if (index != -1) {
          list.splice(index, 1);
        }
      }
      return cat;
    };
    newState.categories = newState.categories.map(processCategory);
    recountTotal(newState);
    recountProductsOverlays(newState);
  }

  return newState;
};

const updateProductInArray = (products, newProduct) => {
  return products.map(product => {
    return product.id === newProduct.id ? newProduct : product;
  });
};

const processProductUpdate = (state, action) => {
  const newState = clone(state);
  const { categories } = newState;

  if (categories) {
    const categoryIndex = categories.findIndex(({ id }) => id === action.payload.categoryId);
    const category = categories[categoryIndex];
    const { products, alternatives } = category;
    category.products = updateProductInArray(products, action.payload.product);
    category.alternatives = updateProductInArray(alternatives, action.payload.product);
    categories[categoryIndex] = category;
    recountTotal(newState);
    return newState;
  }
  return state;
};

const processProductSelect = (state, action) => {
  let newState = clone(state);
  newState.selectedProduct = action.payload.product;
  return newState;
};

const processSwitchRename = (state, action) => {
  let newState = clone(state);
  let processCategory = cat => {
    let newCat = { ...cat };
    if (cat.id === action.payload.category.id) {
      newCat.isEditMode = action.payload.isEditMode;
    }
    return newCat;
  };
  newState.categories = newState.categories.map(processCategory);
  return newState;
};

const processCategoryAttrsUpdate = (state, categoryId, callbackFn) => {
  const newState = clone(state);
  const processCategory = cat => {
    let newCat = cat;
    if (cat.id === categoryId) {
      newCat = clone(cat);
      callbackFn(newCat);
    }
    return newCat;
  };
  newState.categories = newState.categories.map(processCategory);
  return newState;
};

const processRename = (state, action) => {
  const newState = processCategoryAttrsUpdate(state, action.payload.category.id, newCat => {
    newCat.name = action.payload.newName;
  });
  recountProductsOverlays(newState);
  return newState;
};

const processCreate = (state, action) => {
  let newState = clone(state, { drag: {} });

  let index = newState.categories.findIndex(i => i.id === -1);
  if (index !== -1) {
    newState.categories.splice(index, 1, action.payload);
  }

  recountTotal(newState);
  recountProductsOverlays(newState);
  showOnboardingMessage(newState);
  return newState;
};

const processRemove = (state, action) => {
  let newState = clone(state);
  const index = newState.categories.findIndex(i => i.id === action.payload.id);
  if (index !== -1) {
    newState.categories.splice(index, 1);
  }
  recountTotal(newState);
  recountProductsOverlays(newState);
  return newState;
};

const processCategoryToggleFavourite = (state, action) => {
  const newState = processCategoryAttrsUpdate(state, action.payload.category.id, newCat => {
    newCat.favourite = action.payload.favourite;
  });
  return newState;
};

const processCategoryOpenCopyDialog = (state, action) => {
  const newState = clone(state);
  const { category } = action.payload;
  const { copyCategoryDialog } = state;
  const params = { copyCategoryDialog: { ...copyCategoryDialog, category } };
  return { ...newState, ...params };
};

const processCategoryRelease = (state, action) => {
  const newState = processCategoryAttrsUpdate(state, action.payload.category.id, newCat => {
    newCat.category_release = action.payload.categoryRelease;
  });
  return newState;
};

const processCategoryPlaceholder = (state, action) => {
  if (state.drag.product) {
    let newState = clone(state);

    let index = newState.categories.findIndex(i => i.id === -1);
    if (index !== -1) {
      newState.categories.splice(index, 1);
    }

    if (action.payload.action === CREATE_PLACEHOLDER_ACTION) {
      let placeholder = { id: -1, column: action.payload.category.column };

      let index = newState.categories.findIndex(i => i.id === action.payload.category.id);
      if (index !== -1) {
        placeholder.position = getCategoryPos(newState.categories, action.payload.category);
        newState.categories.splice(index, 0, placeholder);
      } else {
        placeholder.position = getColumnSize(newState.categories, action.payload.category.column);
        newState.categories.push(placeholder);
      }
    }

    return newState;
  }
  return state;
};

const processDropBeforeCreate = (state, action) => {
  return clone(state, { drag: {} });
};

// ------------------------------------
// Action Handlers
// ------------------------------------
export const CATEGORIES_ACTION_HANDLERS = {
  [MOOD_CATEGORY_LOADING]: processLoading,
  [MOOD_REMOVE_PRODUCT]: processProductRemove,
  [MOOD_SELECT_PRODUCT]: processProductSelect,
  [MOOD_CATEGORY_SWITCH_RENAME]: processSwitchRename,
  [MOOD_CATEGORY_CATEGORY_RELEASE]: processCategoryRelease,
  [MOOD_CATEGORY_TOGGLE_FAVOURITE]: processCategoryToggleFavourite,
  [MOOD_CATEGORY_COPY_DIALOG]: processCategoryOpenCopyDialog,
  [MOOD_CATEGORY_RENAME]: processRename,
  [MOOD_CATEGORY_CREATE]: processCreate,
  [MOOD_CATEGORY_REMOVE]: processRemove,
  [MOOD_UPDATE_PRODUCT]: processProductUpdate,
  [MOOD_CATEGORY_PLACEHOLDER]: processCategoryPlaceholder,
  [MOOD_DROP_BEFORE_CREATE]: processDropBeforeCreate,
};



// WEBPACK FOOTER //
// ./app/javascript/design/routes/Moodboard/modules/moodboard-categories.js